import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { ApiAmenaService } from '../../services/api-amena.service';
import { TerminalDeliveryService } from '../../services/terminal-delivery.service';
import { NormalizadorService } from '../../services/normalizador.service';
import { GeneralService } from '../../services/general.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { autocompleteValidator } from 'src/app/utils/validators/autocomplete-validator';
import { TerminalDeliveryListener } from '../../interface/terminal-delivery-listener';
import { TerminalDeliveryModel } from '../../interface/terminal-delivery-model';
import { PriceDelivery } from '../../classes/priceDelivery';
import { onChangeZip, searchRoadType } from 'src/app/utils/normalizerFunctions';
import { Router } from '@angular/router';

@Component({
    selector: 'app-terminal-delivery',
    templateUrl: './terminal-delivery.component.html',
    styleUrls: ['./terminal-delivery.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class TerminalDeliveryComponent implements OnInit, OnDestroy {
    @Input() listener: TerminalDeliveryListener;
    @Input() userForm = null;

    public pdv;
    public country = 'es';
    public offices: any[] = [];
    public office: any = null;
    public deliveryPrice = PriceDelivery.PRICE_ALTA_DIR_CONTACTO;
    public confirmedAddress = '';
    public roadTypes: any[] = [];
    public provinces: any[] = [];
    public formGroup: FormGroup;
    public errorForm = false;
    public model = new TerminalDeliveryModel();
    public isLoading = false;
    public showCorreosOption = true;
    private isRetramitacion = false;
    private subscribeRetramicion;
    public staircaseTypes: any[] = [];
    public floorTypes: any[] = [];
    public staircaseFilteredOptions: Observable<any[]>;
    public floorFilteredOptions: Observable<any[]>;
    public controlValidatorFloor = false;
    public router: string;
    public datosCobertura: any;
    public showSendContactAddress: boolean = true;
    public showErrorZip: boolean = false;

    constructor(
        private modalService: NgbModal,
        private formBuilder: FormBuilder,
        protected amenaService: ApiAmenaService,
        protected terminalDeliveryService: TerminalDeliveryService,
        private normalizadorService: NormalizadorService,
        private generalService: GeneralService,
        private shoppingCartService: ShoppingCartService,
        private _router: Router
    ) {
        this.router = _router.url;
    }

    ngOnInit(): void {
        this.model.type = 3;
        this.model.deliveryPrice = PriceDelivery.PRICE_ALTA_DIR_CONTACTO;

        this.amenaService.getPDV()
            .subscribe((data) => {
                this.pdv = data;
            });

        this.formGroup = this.formBuilder.group({
            office: [''],
            full_name: [''],
            phone: [''],
            road_type: [''],
            address: [''],
            number: [''],
            floor: [''],
            door: [''],
            stairway: [''],
            zip: [''],
            city: [''],
            province: [''],
            additional_info: ['']
        });

        this.amenaService.getDatosTipoVia()
            .subscribe((data: any) => {
                if (data != null) {
                    this.roadTypes = data;
                }
            });

        this.amenaService.getProvincias()
            .subscribe((data: any) => {
                if (data) {
                    this.provinces = data;
                }                
            });

        this.formGroup.get('province').disable();

        this.subscribeRetramicion = this.generalService.getEmptyFormTerminalDelivery()
            .subscribe((data: any) => {
                if (data) {
                    this.isRetramitacion = true;
                    this.setData(data);
                }
            });

        this.generalService.getFormularioMobilePack()
            .subscribe((data: any) => {
                if (data) {
                	this.evaluateShopingCart();
                }
            })

        this.amenaService.getStaircaseTypes()
            .subscribe((data: any[]) => {
                if (data != null) {
                    this.staircaseTypes = data;
                    this.staircaseFilteredOptions = this.formGroup.get('stairway').valueChanges.pipe(
                        startWith(''),
                        map(value => this._filter(value, this.staircaseTypes))
                    );
                }
            });

        this.amenaService.getFloorTypes()
            .subscribe((data: any[]) => {
                if (data != null) {
                    this.floorTypes = data;
                    this.floorFilteredOptions = this.formGroup.get('floor').valueChanges.pipe(
                        startWith(''),
                        map(value => this._filter(value, this.floorTypes))
                    );
                    if (this.isRetramitacion === true) {
                        this.formGroup.get('floor').setValidators(autocompleteValidator(this.floorTypes.map(i => i.code)));
                        this.controlValidatorFloor = true;
                    }
                }
            });

        this.normalizadorService.getResultadoCobertura()
            .subscribe((value) => {
                this.datosCobertura = value;
                if (
                    this.datosCobertura &&
                    this.datosCobertura.value.resultadoConsultaCobertura && 
                    this.datosCobertura.value.resultadoConsultaCobertura.cimaStairOtherCode && 
                    this.datosCobertura.value.resultadoConsultaCobertura.cimaStairOtherCode !== '' &&
                    this.router === '/amena/convergente'
                ) {
                    this.showSendContactAddress = false;
                    this.model.type = 2;
                    this.changeDeliveryPrice(this.model.type);
                } else {
                    this.showSendContactAddress = true;
                }              
            });
    }

    open(content) {
        this.modalService.open(content, {size: 'lg', centered: true});
    }

    getOfficesByZip(zip: string) {
        if (zip.length >= 5) {
            this.offices = [];
            this.office = null;
            this.isLoading = true;
            this.showErrorZip = false;
            this.formGroup.get('zip').disable();

            this.terminalDeliveryService.getOffices(zip)
                .subscribe((data: any[]) => {
                    this.offices = data;
                    // Si hay oficinas marca la primera activa salvo en caso de retramitación
                    if (this.offices.length > 0 && this.office === null) {
                        this.office = this.offices[0];
                        this.formGroup.get('office').patchValue(this.office);
                    }

                    this.isLoading = false;
                    this.formGroup.get('zip').enable();
                }, error => {
                    console.error('getOfficesByZip', error);
                    this.isLoading = false;
                    this.showErrorZip = true;
                    this.formGroup.get('zip').enable();
                });
        }
    }

    selectOffice(i, office) {
        this.office = office;
        this.formGroup.get('office').patchValue(this.office);
    }

    changeDeliveryPrice(type) {
        this.model.type = parseInt(type, null);
        this.formGroup.get('office').clearValidators();
        this.formGroup.get('full_name').clearValidators();
        this.formGroup.get('phone').clearValidators();
        this.formGroup.get('road_type').clearValidators();
        this.formGroup.get('address').clearValidators();
        this.formGroup.get('number').clearValidators();
        this.formGroup.get('zip').clearValidators();
        this.formGroup.get('city').clearValidators();
        this.formGroup.get('province').clearValidators();
        this.formGroup.get('floor').clearValidators();
        this.formGroup.get('stairway').clearValidators();

        switch (this.model.type) {
            case 0:
                this.deliveryPrice = 0;
                break;
            case 1:
                this.deliveryPrice = PriceDelivery.PRICE_ALTA_DIR_CORREOS;
                this.formGroup.get('zip').setValidators(Validators.required);
                this.formGroup.get('office').setValidators(Validators.required);
                const zipVAlue = this.formGroup.get('zip').value;
                if (zipVAlue && zipVAlue !== '' && !this.office) {
                    this.getOfficesByZip(zipVAlue);
                }
                break;
            case 2:
                this.deliveryPrice = this.showCorreosOption ? PriceDelivery.PRICE_ALTA_DIR_CONTACTO : PriceDelivery.PRICE_PORTA_DIR_CONTACTO;
                this.formGroup.get('full_name').setValidators(Validators.required);
                this.formGroup.get('phone').setValidators(Validators.required);
                // this.formGroup.get('road_type').setValidators(Validators.required);
                this.formGroup.get('address').setValidators(Validators.required);
                this.formGroup.get('number').setValidators(Validators.required);
                this.formGroup.get('zip').setValidators(Validators.required);
                this.formGroup.get('city').setValidators(Validators.required);
                this.formGroup.get('province').setValidators(Validators.required);
                this.formGroup.get('stairway').setValidators(autocompleteValidator(this.staircaseTypes.map(i => i.code)));
                this.formGroup.get('floor').setValidators(autocompleteValidator(this.floorTypes.map(i => i.code)));
                // Cuando se realiza una retramitación el valor floortypes es null en este momento, lo limpiamos y añadimos más tarde la validación
                if (this.isRetramitacion === true && this.formGroup.get('floor').value !== null && this.controlValidatorFloor === false) {
                  this.formGroup.get('floor').setValidators([]);
                  this.formGroup.get('floor').clearValidators();
                  this.formGroup.get('floor').updateValueAndValidity();
                }
                break;
            case 3:
              this.deliveryPrice = this.showCorreosOption ? PriceDelivery.PRICE_ALTA_DIR_CONTACTO : PriceDelivery.PRICE_PORTA_DIR_CONTACTO;
              break;
            default:
                this.deliveryPrice = this.showCorreosOption ? PriceDelivery.PRICE_ALTA_DIR_CONTACTO : PriceDelivery.PRICE_PORTA_DIR_CONTACTO;
                break;
        }

        this.model.deliveryPrice = this.deliveryPrice;

        this.formGroup.get('full_name').updateValueAndValidity();
        this.formGroup.get('phone').updateValueAndValidity();
        this.formGroup.get('office').updateValueAndValidity();
        this.formGroup.get('road_type').updateValueAndValidity();
        this.formGroup.get('address').updateValueAndValidity();
        this.formGroup.get('number').updateValueAndValidity();
        this.formGroup.get('zip').updateValueAndValidity();
        this.formGroup.get('city').updateValueAndValidity();
        this.formGroup.get('province').updateValueAndValidity();
        this.formGroup.get('stairway').updateValueAndValidity();
        this.formGroup.get('floor').updateValueAndValidity();
    }

    confirmDelivery() {
        this.model.pdvData = null;
        this.model.mailData = null;
        this.model.courierData = null;

        this.formGroup.markAllAsTouched();
        this.formGroup.updateValueAndValidity();

        if (this.formGroup.valid) {
            if (this.model.type === 0) {
                this.confirmedAddress = this.pdv.info.name;
                this.model.pdvData = this.pdv;
            } else if (this.model.type === 1) {
                this.confirmedAddress = 'En Correos: ' + this.office.name;
                this.model.mailData = this.office;
            } else if (this.model.type === 2) {
                this.confirmedAddress = this.formGroup.get('address').value + ' ' +
                    this.formGroup.get('number').value + ', ' +
                    this.formGroup.get('city').value + ', ' +
                    this.formGroup.get('province').value;
                this.model.courierData = this.formGroup.getRawValue();
            } else {
                this.confirmedAddress = 'Enviar a la dirección de contacto';
            }

            this.listener.onSelectTerminalDelivery(this.model);
            // Se agregó para mostrarlo en el SghoppingCar
            this.terminalDeliveryService.setTerminalDelivery(this.model);
            this.modalService.dismissAll();
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    closeModal() {
        if (this.formGroup.valid) {
            this.modalService.dismissAll();
        } else {
            const elements: any = document.getElementsByClassName('mat-input-element ng-invalid');

            if (elements.length > 0) {
                elements[0].focus();
            }
        }
    }

    onAutocompleteSelected($event) {
        const addressComponents: any[] = $event.address_components;

        if (addressComponents && addressComponents.length > 0) {
            this.formGroup.get('road_type').patchValue('');
            this.formGroup.get('address').patchValue('');
            this.formGroup.get('number').patchValue('');
            this.formGroup.get('floor').patchValue('');
            this.formGroup.get('door').patchValue('');
            this.formGroup.get('stairway').patchValue('');
            this.formGroup.get('zip').patchValue('');
            this.formGroup.get('city').patchValue('');
            this.formGroup.get('province').patchValue('');

            for (const addressComponent of addressComponents) {
                let field = '';
                const types: string[] = addressComponent.types;
                let value: string = addressComponent.long_name;

                if (types.includes('route')) {
                    field = 'address';
                    value = searchRoadType(value, this.roadTypes, 'code', this.formGroup.get('road_type'));
                } else if (types.includes('street_number')) {
                    field = 'number';
                } else if (types.includes('postal_code')) {
                    field = 'zip';
                    this.onChangeZip(value);
                } else if (types.includes('locality')) {
                    field = 'city';
                } else if (types.includes('administrative_area_level_2')) {
                    field = 'province';
                    value = value.toUpperCase();
                }

                if (field !== '') {
                    this.formGroup.get(field).patchValue(value);
                }
            }
        }
    }

    copyUserData() {
        const userData = this.userForm;

        if (userData) {
            const fullName = userData.get('firstName').value + ' ' +
                userData.get('surname1').value + ' ' +
                userData.get('surname2').value;

            this.formGroup.get('full_name').patchValue(fullName.trim());
            this.formGroup.get('phone').patchValue(userData.get('phone').value);
            this.formGroup.get('road_type').patchValue(userData.get('tipoVia').value);
            this.formGroup.get('address').patchValue(userData.get('nombreVia').value);
            this.formGroup.get('number').patchValue(userData.get('numero').value);
            this.formGroup.get('floor').patchValue(userData.get('planta').value);
            this.formGroup.get('door').patchValue(userData.get('puerta').value);
            this.formGroup.get('stairway').patchValue(userData.get('escalera').value);
            this.formGroup.get('zip').patchValue(userData.get('codigoPostal').value);
            this.formGroup.get('city').patchValue(userData.get('localidad').value);
            this.formGroup.get('province').patchValue(userData.get('provincia').value);
            if (
                this.datosCobertura && this.datosCobertura.value.resultadoConsultaCobertura && 
                this.datosCobertura.value.resultadoConsultaCobertura.cimaStairOtherCode && 
                this.datosCobertura.value.resultadoConsultaCobertura.cimaStairOtherCode !== ''
            ) {
                this.formGroup.get('additional_info').patchValue('Escalera: ' + this.datosCobertura.value.resultadoConsultaCobertura.cimaStairOtherCode)
            }
            this.onChangeZip(userData.get('provincia').value);
        }
    }

    onChangeZip(value) {
        onChangeZip(value, this.provinces, 'postal_code', this.formGroup.get('province'));
    }

    setData(data: TerminalDeliveryModel) {
        if (data && typeof data !== 'undefined') {
            if (data.type === 2) {
                this.formGroup.get('office').patchValue(data.courierData.office);
                this.formGroup.get('full_name').patchValue(data.courierData.full_name);
                this.formGroup.get('phone').patchValue(data.courierData.phone);
                this.formGroup.get('road_type').patchValue(data.courierData.road_type);
                this.formGroup.get('address').patchValue(data.courierData.address);
                this.formGroup.get('number').patchValue(data.courierData.number);
                this.formGroup.get('floor').patchValue(data.courierData.floor);
                this.formGroup.get('door').patchValue(data.courierData.door);
                this.formGroup.get('stairway').patchValue(data.courierData.stairway);
                this.formGroup.get('zip').patchValue(data.courierData.zip);
                this.formGroup.get('city').patchValue(data.courierData.city);
                this.formGroup.get('province').patchValue(data.courierData.province);
                this.formGroup.get('additional_info').patchValue(data.courierData.additional_info);
            } else if(data.type === 1) {
                this.getOfficesByZip(data.courierData.zip);
                this.formGroup.get('zip').patchValue(data.courierData.zip);
                this.formGroup.get('office').patchValue(data.mailData.id);
                if (this.isRetramitacion === true) {
                    this.selectOffice('', data.mailData);
                }
            }
            this.model.type = data.type;
            if (this.isRetramitacion === true) {
                this.changeDeliveryPrice(data.type);
                this.confirmDelivery();
            }
        }
    }

    evaluateShopingCart() {
        const itemsCart = this.shoppingCartService.getShoppingCart().getItems();
        if (itemsCart && itemsCart.length) {
            // Buscamos si alguna de las lineas de movil son alta
            const found = itemsCart.find(item => item.portability === '');
            if (found) { // Alguna alta
                this.showCorreosOption = true;
                this.model.deliveryPrice = this.deliveryPrice = PriceDelivery.PRICE_ALTA_DIR_CONTACTO;
                if (this.confirmedAddress !== '') {
                    this.changeDeliveryPrice(this.model.type);
                    this.confirmDelivery();
                }
            } else { // Todos portabilidad
                this.showCorreosOption = false;
                this.model.type = this.model.type && this.model.type === 1 ? 3 : this.model.type;
                this.model.deliveryPrice = this.deliveryPrice = PriceDelivery.PRICE_PORTA_DIR_CONTACTO;
                if (this.confirmedAddress !== '') {
                    this.changeDeliveryPrice(this.model.type);
                    this.confirmDelivery();
                }
            }
        }
    }

    ngOnDestroy(): void {
        this.subscribeRetramicion.unsubscribe();
        this.confirmedAddress = '';
    }

    private _filter(value: string, values: any[]): any[] {
        const filterValue = value.toLowerCase();

        const auxValues = values.filter(option => option.description.toLowerCase().includes(filterValue));
        return auxValues && auxValues.length === 0 ? values : auxValues;
    }
}
